(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lila-design"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lila-carousel')) {
    customElements.define('lila-carousel', class extends HTMLElement {
      connectedCallback() {
        this.cleanup?.abort();
        this.cleanup = new AbortController();
        const signal = this.cleanup.signal;
        this.track = this.querySelector('.lila-blends');
        if (!this.track) return;
        const update = () => {
          const slides = Array.from(this.track.children);
          const trackLeft = this.track.getBoundingClientRect().left;
          let index = 0, nearest = Infinity;
          slides.forEach((slide, i) => { const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft); if (distance < nearest) { nearest = distance; index = i; } });
          this.index = index;
          const status = this.querySelector('[data-carousel-status]');
          if (status) status.textContent = `${index + 1} / ${slides.length}`;
          this.querySelectorAll('[data-direction]').forEach(button => { button.disabled = Number(button.dataset.direction) < 0 ? index === 0 : index === slides.length - 1; });
        };
        this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
          const slide = this.track.children[(this.index || 0) + Number(button.dataset.direction)];
          if (slide) this.track.scrollBy({left:slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        }, { signal }));
        this.track.addEventListener('scroll', () => { clearTimeout(this.timer); this.timer = setTimeout(update, 100); }, {passive:true,signal});
        this.resizeObserver = new ResizeObserver(update); this.resizeObserver.observe(this.track); update();
      }
      disconnectedCallback() { this.cleanup?.abort(); this.resizeObserver?.disconnect(); clearTimeout(this.timer); }
    });
  }
  if (!customElements.get('lila-sticky-buy')) {
    customElements.define('lila-sticky-buy', class extends HTMLElement {
      connectedCallback() {
        const original = document.querySelector('product-info .product-form__submit');
        const trigger = this.querySelector('button');
        if (!original || !trigger) return;
        this.clickHandler = () => { original.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'}); original.focus({preventScroll:true}); };
        trigger.addEventListener('click',this.clickHandler);
        this.observer = new IntersectionObserver(entries => { const entry=entries[0]; this.classList.toggle('is-visible',!entry.isIntersecting && entry.boundingClientRect.top<0); });
        this.observer.observe(original);
      }
      disconnectedCallback() { this.observer?.disconnect(); this.querySelector('button')?.removeEventListener('click',this.clickHandler); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
